import React from 'react';
import { Container, FakePlate, Header, Plate, Row, SubHeader } from 'features/shared/ui/Page';
import UnauthorizedLayout from 'features/shared/layouts/unauthorized';
import Spacer from 'features/shared/Spacer';
import SwitchTabs, { SwitchTabsType } from 'features/shared/SwitchTabs';
import { useBannersContext } from 'features/shared/Banners/BannersContext';
import Banners from 'features/shared/Banners/Banners';
import { UnauthPlateText } from 'features/shared/UnauthPlateText';

const KnowledgeSlices = () => {
  const { banners } = useBannersContext({ section: 'knowledge_slices' });
  return (
    <UnauthorizedLayout>
      <Container>
        <Header>Срезы знаний</Header>
        <Spacer size={40} />

        <Plate data-qa-id="totals_block">
          <SubHeader>Основные показатели по региону</SubHeader>
          <Spacer size={24} />
          <FakePlate style={{ padding: 28 }}>
            <UnauthPlateText />
          </FakePlate>
        </Plate>
        <Spacer size={40} />
        {banners.length ? (
          <>
            <Banners section="knowledge_slices" />
            <Spacer size={40} />
          </>
        ) : null}
        <Plate data-qa-id="results_block">
          <SubHeader>Результаты тестирования в школах</SubHeader>
          <Spacer size={24} />
          <SwitchTabs
            values={[
              { id: 'math', label: 'Математика' },
              { id: 'russian', label: 'Русский Язык' },
              // { id: 'english', label: 'Английский Язык' },
            ]}
            value={{ id: 'math', label: 'Математика' }}
            type={SwitchTabsType.pills}
          />
          <Spacer size={40} />
          <FakePlate style={{ padding: '197px 0' }}>
            <UnauthPlateText />
          </FakePlate>
        </Plate>
        <Spacer size={40} />
        <Plate data-qa-id="count_block">
          <SubHeader>Количество учеников, прошедших тестирование</SubHeader>
          <Spacer size={40} />
          <SwitchTabs
            values={[
              { id: 'math', label: 'Математика' },
              { id: 'russian', label: 'Русский Язык' },
              // { id: 'english', label: 'Английский Язык' },
            ]}
            value={{ id: 'math', label: 'Математика' }}
            type={SwitchTabsType.pills}
          />
          <Spacer size={40} />
          <FakePlate style={{ padding: '197px 0' }}>
            <UnauthPlateText />
          </FakePlate>
        </Plate>
        <Spacer size={40} />
        <Plate data-qa-id="answers_block">
          <SubHeader>Процент правильных ответов</SubHeader>
          <Spacer size={40} />
          <SwitchTabs
            values={[
              { id: 'math', label: 'Математика' },
              { id: 'russian', label: 'Русский Язык' },
              // { id: 'english', label: 'Английский Язык' },
            ]}
            value={{ id: 'math', label: 'Математика' }}
            type={SwitchTabsType.pills}
          />
          <Spacer size={40} />
          <FakePlate style={{ padding: '197px 0' }}>
            <UnauthPlateText />
          </FakePlate>
        </Plate>
      </Container>
    </UnauthorizedLayout>
  );
};

export default KnowledgeSlices;
